import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";


const AddPlanService = () => {
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })

    const [planServiceName, setPlanServiceName] = useState('');
    // const Navigate = useNavigate();

    const addServiceApi = () => {
        console.log(planServiceName);
        Axios
            .post("api/bussiness/plan-services", {
                service_name: planServiceName,
            })
            .then((response) => {
                console.log(response);
                setPlanServiceName('');
                setNotify({
                    isOpen: true,
                    messsage: "Added Successfully",
                    type: 'success'
                })
            }).catch((error) => {
                setNotify({
                    isOpen: true,
                    messsage: "already exits service",
                    type: 'warning'
                })
            });
    }
    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Add Service</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%", marginTop: "10px" }}>

                                <div className="form-group mb-3">
                                    <label htmlFor="group-name">Service Name</label>
                                    <input
                                        onChange={(e) => setPlanServiceName(e.target.value)}
                                        id="group-name"
                                        value={planServiceName}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Service name"
                                    />

                                </div>
                                <button onClick={addServiceApi} className="btn btn-gradient btn-block" type="submit"> Submit </button>

                            </div>
                            {
                                notify.isOpen ?
                                    <Notification
                                        notify={notify}
                                        setNotify={setNotify} />
                                    : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPlanService;